import { AppWindow } from '@app/entities/app-window';

export function dimensionImageProxy(window: AppWindow, heightImagePx: number, dicountWidthImagePx: number = 0): string {
  const dimension = `x${heightImagePx}`;
  if (typeof window === 'undefined') return dimension;
  const widthScreen = window['innerWidth']
    || document?.documentElement?.clientWidth
    || document?.body?.clientWidth;
  return widthScreen ? `${widthScreen - dicountWidthImagePx}x${heightImagePx}` : dimension;
}
